<template>
  <div class="home-pc-index">
    <!-- 头部标题 -->
    <div class="header">
      <img src="./imgs/header-img-2.png" class="header-bg" style="margin-top: 10px" />
      <div class="header-content">
        <!-- <h1 class="title">朝阳区人事考试智能指挥调度一体化平台</h1> -->
        <div class="date" @click="goBack">{{ currentDate }}</div>
        <div class="exam-info" @click="goToBigScreen2">2026年度上半年事业单位公开招聘笔试</div>
      </div>
    </div>

    <!-- 左侧统计面板 -->
    <div class="left-panel">
      <!-- 考生数量 -->
      <div class="card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>考生数量</span>
        </div>
        <div class="card-content">
          <div class="stat-row">
            <div class="stat-info">
              <span class="stat-label">2026年上半年考生总体数量</span>
              <span class="stat-trend up">↑ 同比增长 22.3%</span>
            </div>
            <span class="stat-value">17782人</span>
          </div>
          <div ref="chartExaminee" class="chart-container"></div>
        </div>
      </div>

      <!-- 考生年龄/性别统计 -->
      <div class="card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>考生年龄/性别统计</span>
        </div>
        <div class="card-content">
          <div class="gender-stats">
            <div class="gender-item">
              <span class="gender-icon male"></span>
              <span class="gender-num">5295</span>
            </div>
            <div class="gender-item">
              <span class="gender-icon female"></span>
              <span class="gender-num">12487</span>
            </div>
          </div>
          <div ref="chartAge" class="chart-container"></div>
        </div>
      </div>

      <!-- 学历学位 -->
      <div class="card edu-degree-card">
        <div class="card-title">
          <span class="title-icon"></span>
          <div class="tab-header">
            <span 
              class="tab-item" 
              :class="{ active: activeTab === 'edu' }" 
              @click="activeTab = 'edu'"
            >学历</span>
            <span 
              class="tab-item" 
              :class="{ active: activeTab === 'degree' }" 
              @click="activeTab = 'degree'"
            >学位</span>
          </div>
        </div>
        <div class="rank-list compact" v-show="activeTab === 'edu'">
          <div v-for="(item, index) in eduRank" :key="index" class="rank-item">
            <span class="rank-num" :class="'rank-' + (index + 1)">NO.{{ index + 1 }}</span>
            <span class="rank-name">{{ item.name }}</span>
            <span class="rank-bar">
              <span class="rank-progress" :style="{ width: item.percent + '%' }"></span>
            </span>
            <span class="rank-value">{{ item.value }} ({{ item.percent }}%)</span>
          </div>
        </div>
        <div class="rank-list compact" v-show="activeTab === 'degree'">
          <div v-for="(item, index) in degreeRank" :key="index" class="rank-item">
            <span class="rank-num" :class="'rank-' + (index + 1)">NO.{{ index + 1 }}</span>
            <span class="rank-name">{{ item.name }}</span>
            <span class="rank-bar">
              <span class="rank-progress blue" :style="{ width: item.percent + '%' }"></span>
            </span>
            <span class="rank-value">{{ item.value }} ({{ item.percent }}%)</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 地图容器 -->
    <div id="mapContainer"></div>

    <!-- 右侧统计面板 -->
    <div class="right-panel">
      <!-- 精准布防 -->
      <div class="card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>精准布防</span>
        </div>
        <div class="card-content">
          <div class="unit-label"></div>
          <div ref="chartDefense" class="chart-container"></div>
        </div>
      </div>

      <!-- 重点人问题分析 -->
      <div class="card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>重点人问题分析</span>
        </div>
        <div class="card-content problem-analysis" style="display: flex;flex-direction: row !important;">
          <div ref="chartProblem" class="chart-container" style="width: 40%;"></div>
          <div class="problem-legend" style="width: 60%;">
            <div class="legend-item">
              <span class="legend-dot" style="background: #00d4ff;"></span>
              <span class="legend-text">即将到达报考年限（38+）</span>
              <span class="legend-num">26人</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot" style="background: #00ff88;"></span>
              <span class="legend-text">对试题和成绩提出异议</span>
              <span class="legend-num">1人</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot" style="background: #ff6600;"></span>
              <span class="legend-text">往期考试违纪违规行为</span>
              <span class="legend-num">1人</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 岗位TOP5 -->
      <div class="card post-top5-card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>岗位TOP5</span>
        </div>
        <div class="rank-list">
          <div v-for="(item, index) in postRank" :key="index" class="rank-item">
            <span class="rank-num" :class="'rank-' + (index + 1)">NO.{{ index + 1 }}</span>
            <span class="rank-name" :title="item.name">{{ item.name }}</span>
            <span class="rank-bar">
              <span class="rank-progress cyan" :style="{ width: item.percent + '%' }"></span>
            </span>
            <span class="rank-value">{{ item.value }} ({{ item.percent }}%)</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部统计面板 -->
    <div class="bottom-panel">
      <div class="card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>毕业院校TOP5</span>
        </div>
        <div class="rank-list">
          <div v-for="(item, index) in schoolRank" :key="index" class="rank-item">
            <span class="rank-num" :class="'rank-' + (index + 1)">NO.{{ index + 1 }}</span>
            <span class="rank-name" :title="item.name">{{ item.name }}</span>
            <!-- <span class="rank-bar">
              <span class="rank-progress" :style="{ width: item.percent + '%' }"></span>
            </span> -->
            <span class="rank-value">{{ item.value }} ({{ item.percent }}%)</span>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>报考单位TOP5</span>
        </div>
        <div class="rank-list">
          <div v-for="(item, index) in unitRank" :key="index" class="rank-item">
            <span class="rank-num" :class="'rank-' + (index + 1)">0{{ index + 1 }}</span>
            <span class="rank-name" :title="item.fullName || item.name">{{ item.name }}</span>
            <!-- <span class="rank-bar">
              <span class="rank-progress blue" :style="{ width: item.percent + '%' }"></span>
            </span> -->
            <span class="rank-value">{{ item.value }}个 {{ item.percent }}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: '',
      MAP: null,
      activeTab: 'edu',
      schoolRank: [
        { name: '北京城市学院', value: 1053, percent: 5.92 },
        { name: '北京联合大学', value: 801, percent: 4.50 },
        { name: '首都经济贸易大学', value: 750, percent: 4.22 },
        { name: '北京建筑大学', value: 678, percent: 3.81 },
        { name: '北京工商大学', value: 664, percent: 3.73 }
        // { name: '北方工业大学', value: 610, percent: 3.43 },
        // { name: '北京工业大学', value: 520, percent: 2.92 },
        // { name: '北京信息科技大学', value: 506, percent: 2.85 },
        // { name: '北京农学院', value: 422, percent: 2.37 },
        // { name: '北京物资学院', value: 412, percent: 2.32 }
      ],
      unitRank: [
        { name: '教育委员会', fullName: '中共北京市朝阳区委教育工作委员会、北京市朝阳区教育委员会-北京市朝阳区教育服务保障中心', value: 2330, percent: 13.10 },
        { name: '南磨房乡人民政府', fullName: '北京市朝阳区南磨房乡人民政府-北京市朝阳区南磨房乡（地区）市民诉求处置中心（北京市朝阳区南磨房乡（地区）综治中心）', value: 897, percent: 5.04 },
        { name: '人力资源和社会保障局', fullName: '北京市朝阳区人力资源和社会保障局-北京市朝阳区人力资源公共服务中心', value: 701, percent: 3.94 },
        { name: '机关事务管理服务中心', fullName: '北京市朝阳区机关事务管理服务中心-北京市朝阳区机关事务管理服务中心', value: 619, percent: 3.48 },
        { name: '科学技术和信息化局', fullName: '北京市朝阳区科学技术和信息化局-北京市朝阳区科技创新服务中心', value: 587, percent: 3.30 }
        // { name: '北京市朝阳区水务局', fullName: '北京市朝阳区水务局-北京市朝阳区河道管理一所', value: 575, percent: 3.23 },
        // { name: '北京市朝阳区退役军人事务局', fullName: '北京市朝阳区退役军人事务局-北京市朝阳区军队离休退休干部服务管理中心', value: 547, percent: 3.08 },
        // { name: '北京市朝阳区民政局', fullName: '北京市朝阳区民政局-北京市朝阳区社区服务中心', value: 448, percent: 2.52 },
        // { name: '北京市朝阳区来广营乡人民政府', fullName: '北京市朝阳区来广营乡人民政府-北京市朝阳区来广营乡农村合作经济经营管理站', value: 435, percent: 2.45 },
        // { name: '北京市朝阳区司法局', fullName: '北京市朝阳区司法局-北京市朝阳区社区矫正中心（北京市朝阳区行政复议受理中心）', value: 414, percent: 2.33 }
      ],
      postRank: [
        { name: '综合管理岗', value: 3722, percent: 20.93 },
        { name: '综合管理岗（引贤计划）', value: 2184, percent: 12.28 },
        { name: '国有资产接收处置岗', value: 1479, percent: 8.32 },
        { name: '综合服务岗（引贤计划）', value: 507, percent: 2.85 },
        { name: '基建工程技术岗', value: 469, percent: 2.64 },
        // { name: '综合事务管理岗', value: 469, percent: 2.64 },
        // { name: '资产管理岗', value: 435, percent: 2.45 },
        // { name: '服务管理岗', value: 386, percent: 2.17 },
        // { name: '水环境管护岗', value: 338, percent: 1.90 },
        // { name: '科技创新管理岗（引贤计划）', value: 330, percent: 1.86 }
      ],
      eduRank: [
        { name: '硕士研究生', value: 9216, percent: 51.85 },
        { name: '大学本科', value: 8192, percent: 46.07 },
        { name: '博士研究生', value: 350, percent: 1.97 },
        { name: '大学专科', value: 22, percent: 0.12 },
        // { name: '高中', value: 2, percent: 0.01 }
      ],
      degreeRank: [
        { name: '硕士', value: 9221, percent: 13.62 },
        { name: '学士', value: 8035, percent: 11.87 },
        { name: '博士', value: 350, percent: 0.52 },
        { name: '双学士学位', value: 142, percent: 0.21 },
        { name: '无', value: 34, percent: 0.05 }
      ]
    };
  },
  mounted() {
    this.setCurrentDate();
    this.mapInit();
    this.$nextTick(() => {
      setTimeout(() => {
        this.initCharts();
      }, 500);
    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    goToBigScreen2() {
      this.$router.push('/bigscreen_cy2');
    },
    goBack() {
      this.$router.push('/home_cy');
    },
    setCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      this.currentDate = `${year}-${month}-${day}`;
    },
    handleResize() {
      this.chartExaminee && this.chartExaminee.resize();
      this.chartAge && this.chartAge.resize();
      this.chartEdu && this.chartEdu.resize();
      this.chartDegree && this.chartDegree.resize();
      this.chartDefense && this.chartDefense.resize();
      this.chartProblem && this.chartProblem.resize();
    },
    mapInit() {
      let this_ = this;
      var options = {
        extensions: "all",
        level: "district"
      };
      var district = new AMap.DistrictSearch(options);
      district.search("朝阳区", function(status, result) {
        var bounds = result.districtList[0]["boundaries"];
        var map = new AMap.Map("mapContainer", {
          mapStyle: "amap://styles/darkblue",
          resizeEnable: true,
          zoom: 11.5,
          center: [116.525487, 39.930956],
          features: ["bg", "road", "building"]
        });
        for (var i = 0; i < bounds.length; i++) {
          new AMap.Polyline({
            path: bounds[i],
            strokeColor: "#00d4ff",
            strokeWeight: 2,
            map: map
          });
        }
        this_.MAP = map;
        this_.addMapMarkers(map);
      });
    },
    addMapMarkers(map) {
      const echarts = require('echarts');
      const examPoints = [
        { name: "北京联合大学(北四环校区)", position: [116.427083,39.990922], type: 2 },
        { name: "北京市对外贸易学校", position: [116.440044,40.053023], type: 2 },
        { name: "北京联合大学师范学院", position: [116.399803,39.963821], type: 2 },
        { name: "北京市自动化工程学校", position: [116.370391,40.008436], type: 2 },
        { name: "北京联合大学生物化学工程学院（南区）", position: [116.506406,39.862274], type: 2 },
        { name: "北京财贸职业学院(朝阳校区)", position: [116.47413,39.928257], type: 2 },
        { name: "北京联合大学商务学院", position: [116.48689,39.922004], type: 2 },
        { name: "北京联合大学机器人学院", position: [116.458345,39.930509], type: 2 },
        { name: "朝阳区指挥调度中心", position: [116.498924,39.972483], type: 3 }
      ];

      examPoints.forEach((point, index) => {
        const markerContent = `<div class="custom-marker type-${point.type}">
          <div class="marker-icon"></div>
          <div class="marker-label">${point.name}</div>
        </div>`;

        const marker = new AMap.Marker({
          position: point.position,
          content: markerContent,
          offset: new AMap.Pixel(-15, -30),
          map: map
        });
      });
    },
    initCharts() {
      const echarts = require('echarts');

      // 考生数量柱状图
      this.chartExaminee = echarts.init(this.$refs.chartExaminee);
      this.chartExaminee.setOption({
        grid: { top: 30, left: 5, right: 15, bottom: 10, containLabel: true },
        xAxis: {
          type: 'category',
          data: ['2024年\n上半年', '2024年\n下半年', '2025年\n上半年', '2025年\n下半年', '2026年\n上半年'],
          axisLine: { lineStyle: { color: '#3c6697' } },
          axisLabel: { color: '#fff', fontSize: 10 }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          splitLine: { lineStyle: { color: '#1a3a5c' } },
          axisLabel: { color: '#fff' }
        },
        series: [{
          data: [13639, 9371, 14535, 9281, 17782],
          type: 'bar',
          barWidth: '50%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#00ff88' },
              { offset: 1, color: '#00aa55' }
            ]),
            borderRadius: [4, 4, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            color: '#00ff88',
            fontSize: 11,
            fontWeight: 'bold',
            formatter: '{c}'
          }
        }]
      });

      // 考生年龄柱状图
      this.chartAge = echarts.init(this.$refs.chartAge);
      this.chartAge.setOption({
        grid: { top: 15, left: 35, right: 15, bottom: 20 },
        xAxis: {
          type: 'category',
          data: ['26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39'],
          axisLine: { lineStyle: { color: '#3c6697' } },
          axisLabel: { color: '#fff', fontSize: 9 }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          splitLine: { lineStyle: { color: '#1a3a5c' } },
          axisLabel: { color: '#fff' }
        },
        series: [{
          data: [2513, 1597, 1072, 881, 796, 635, 538, 484, 403, 328, 329, 228, 232, 130],
          type: 'bar',
          barWidth: '55%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#00c6ff' },
              { offset: 1, color: '#0072ff' }
            ]),
            borderRadius: [3, 3, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            color: '#00c6ff',
            fontSize: 9,
            formatter: function(params) {
              return params.value > 100 ? params.value : '';
            }
          }
        }]
      });

      // 学历饼图


      // 精准布防柱状图
      this.chartDefense = echarts.init(this.$refs.chartDefense);
      this.chartDefense.setOption({
        grid: { top: 30, left: 50, right: 40, bottom: 30 },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: function(params) {
            const name = params[0].name.replace(/\n/g, '');
            return name + '<br/>人数: ' + params[0].value;
          }
        },
        xAxis: {
          type: 'category',
          data: ['北京联合大学\n（北四环校区）', '北京联合大学\n商务学院', '北京市自动化\n工程学校', '北京财贸职业学院\n（朝阳校区）', '北京联合大学生物\n化学工程学院（南区）', '北京联合大学\n师范学院', '北京联合大学\n机器人学院', '北京市对外贸易\n学校'],
          axisLine: { lineStyle: { color: '#3c6697' } },
          axisLabel: { color: '#fff', fontSize: 9 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          splitLine: { lineStyle: { color: '#1a3a5c' } },
          axisLabel: { color: '#fff' }
        },
        series: [{
          data: [11, 4, 5, 2, 2, 1, 1, 2],
          type: 'bar',
          barWidth: '45%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#ffcc00' },
              { offset: 1, color: '#ff9900' }
            ]),
            borderRadius: [4, 4, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            color: '#ffcc00',
            fontSize: 12,
            fontWeight: 'bold',
            formatter: '{c}'
          }
        }]
      });

      // 重点人问题分析饼图
      this.chartProblem = echarts.init(this.$refs.chartProblem);
      this.chartProblem.setOption({
        tooltip: { show: false },
        series: [{
          type: 'pie',
          radius: ['35%', '65%'],
          center: ['40%', '50%'],
          data: [
            { value: 26, name: '即将到达报考年限（38+）', itemStyle: { color: '#00d4ff' } },
            { value: 1, name: '对试题和成绩提出异议', itemStyle: { color: '#00ff88' } },
            { value: 1, name: '往期考试违纪违规行为', itemStyle: { color: '#ff6600' } }
          ],
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          emphasis: {
            scale: false,
            label: { show: false }
          }
        }]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.home-pc-index {
  width: 100vw;
  height: 100vh;
  color: #dbe2ff;
  background: #0a1628;
  overflow: hidden;
  position: relative;

  .header {
    width: 100%;
    height: 110px;
    position: absolute;
    left: 0px;
    top: 0;
    z-index: 10;

    .header-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .header-content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      text-align: center;
      padding-top: 15px;

      .title {
        font-size: 28px;
        font-weight: bold;
        color: #fff;
        text-shadow: 0 0 20px #00d4ff;
        margin: 0;
        letter-spacing: 4px;
      }

      .date {
        position: absolute;
        left: 30px;
        top: 20px;
        font-size: 14px;
        color: #fff;
      }

      .exam-info {
        position: absolute;
        right: 30px;
        top: 20px;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
        // padding: 5px 15px;
        // background: rgba(0, 212, 255, 0.1);
        // border: 1px solid rgba(0, 212, 255, 0.3);
        // border-radius: 4px;
      }
    }
  }

  #mapContainer {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
  }

  // 左侧面板
  .left-panel {
    position: absolute;
    left: 20px;
    top: 120px;
    // width: 420px;
    width: 380px;
    bottom: 15px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .card:not(.edu-degree-card) {
      flex: 1;
      display: flex;
      flex-direction: column;

      .card-content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .chart-container {
        flex: 1;
        height: 100% !important;
      }
    }

    .edu-degree-card {
      height: 210px;
      display: flex;
      flex-direction: column;
    }
  }

  // 右侧面板
  .right-panel {
    position: absolute;
    right: 20px;
    top: 120px;
    width: 380px;
    bottom: 15px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .card:not(.post-top5-card) {
      flex: 1;
      display: flex;
      flex-direction: column;

      .card-content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .chart-container {
        flex: 1;
        height: 100% !important;
      }
    }

    .post-top5-card {
      height: 210px;
      display: flex;
      flex-direction: column;
    }
  }

  // 底部面板
  .bottom-panel {
    position: absolute;
    left: 420px;
    right: 420px;
    bottom: 15px;
    height: 210px;
    z-index: 5;
    display: flex;
    gap: 12px;

    .card {
      flex: 1;
      width: 50%;
      display: flex;
      flex-direction: column;
    }
  }

  // 卡片样式
  .card {
    background: linear-gradient(135deg, rgba(6, 30, 60, 0.92) 0%, rgba(10, 40, 80, 0.92) 100%);
    border: 1px solid rgba(0, 212, 255, 0.25);
    border-radius: 6px;
    padding: 12px 15px;
    position: relative;
    backdrop-filter: blur(10px);

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 30px;
      height: 2px;
      background: #00d4ff;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      width: 30px;
      height: 2px;
      background: #00d4ff;
    }

    &.half {
      flex: 1;
    }

    .card-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 15px;
      font-weight: bold;
      color: #fff;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid rgba(0, 212, 255, 0.3);
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 60px;
        height: 2px;
        background: linear-gradient(90deg, #00d4ff, #0072ff);
      }

      .title-icon {
        width: 4px;
        height: 16px;
        background: linear-gradient(to bottom, #00d4ff, #0072ff);
        border-radius: 2px;
      }

      .tab-header {
        display: flex;
        gap: 0;
        margin-left: auto;
        margin-right: auto;

        .tab-item {
          padding: 4px 16px;
          font-size: 14px;
          cursor: pointer;
          border-bottom: 2px solid transparent;
          transition: all 0.3s ease;
          color: rgba(255, 255, 255, 0.5);

          &:hover {
            color: rgba(255, 255, 255, 0.8);
          }

          &.active {
            color: #fff;
            border-bottom-color: #00d4ff;
          }
        }
      }
    }

    .card-content {
      position: relative;
    }

    .chart-container {
      width: 100%;
      height: 140px;
    }
  }

  // 统一高度的排名卡片
  .post-top5-card,
  .edu-degree-card,
  .bottom-panel .card {
    .rank-list {
      flex: 1;
      justify-content: flex-start;
      overflow-y: auto;
    }
  }

  // 自定义滚动条
  .rank-list::-webkit-scrollbar {
    width: 4px;
  }
  .rank-list::-webkit-scrollbar-track {
    background: rgba(0, 212, 255, 0.05);
    border-radius: 2px;
  }
  .rank-list::-webkit-scrollbar-thumb {
    background: rgba(0, 212, 255, 0.3);
    border-radius: 2px;
  }
  .rank-list::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 212, 255, 0.5);
  }

  .card-row {
    display: flex;
    gap: 15px;
  }

  // 统计行
  .stat-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 5px 0;

    .stat-info {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .stat-label {
        font-size: 12px;
        color: #fff;
      }

      .stat-trend {
        font-size: 10px;
        padding: 2px 6px;
        border-radius: 3px;
        width: fit-content;

        &.up {
          color: #fff;
          background: rgba(0, 255, 136, 0.15);
        }

        &.down {
          color: #fff;
          background: rgba(255, 107, 107, 0.15);
        }
      }
    }

    .stat-value {
      font-size: 20px;
      font-weight: bold;
      color: #fff;
    }
  }

  // 性别统计
  .gender-stats {
    display: flex;
    gap: 40px;
    margin-bottom: 10px;
    padding: 5px 0;

    .gender-item {
      display: flex;
      align-items: center;
      gap: 10px;

      .gender-icon {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #fff;

        &.male {
          background: #00d4ff;
          &::before {
            content: '♂';
          }
        }

        &.female {
          background: #ff6b9d;
          &::before {
            content: '♀';
          }
        }
      }

      .gender-num {
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
      }
    }
  }

  // 单位标签
  .unit-label {
    position: absolute;
    right: 10px;
    top: -25px;
    font-size: 12px;
    color: #fff;
  }

  // 排名列表
  .rank-list {
    display: flex;
    flex-direction: column;
    gap: 10px;

    &.compact {
      gap: 6px;

      .rank-item {
        padding: 2px 0;
      }
    }

    .rank-item {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 12px;
      padding: 4px 0;

      .rank-num {
        width: 45px;
        text-align: center;
        padding: 3px 6px;
        border-radius: 4px;
        font-weight: bold;
        font-size: 11px;
        flex-shrink: 0;

        &.rank-1 {
          background: linear-gradient(135deg, #ffd700, #ffaa00);
          color: #000;
        }

        &.rank-2 {
          background: linear-gradient(135deg, #c0c0c0, #808080);
          color: #000;
        }

        &.rank-3 {
          background: linear-gradient(135deg, #cd7f32, #8b4513);
          color: #fff;
        }

        &.rank-4, &.rank-5 {
          background: rgba(0, 212, 255, 0.15);
          color: #00d4ff;
          border: 1px solid rgba(0, 212, 255, 0.3);
        }
      }

      .rank-name {
        flex: 1;
        color: #fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
      }

      .rank-bar {
        width: 60px;
        height: 6px;
        background: rgba(255, 255, 255, 0.08);
        border-radius: 3px;
        overflow: hidden;
        flex-shrink: 0;

        .rank-progress {
          height: 100%;
          background: linear-gradient(90deg, #00d4ff, #0072ff);
          border-radius: 3px;
          transition: width 0.5s ease;

          &.blue {
            background: linear-gradient(90deg, #0099ff, #6600ff);
          }

          &.cyan {
            background: linear-gradient(90deg, #00ff88, #00d4ff);
          }
        }
      }

      .rank-value {
        width: 100px;
        text-align: right;
        color: #fff;
        font-weight: bold;
        font-size: 11px;
        flex-shrink: 0;
      }
    }
  }

  // 问题分析图例
  .problem-analysis {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    gap: 10px;

    .chart-container {
      flex: 1;
      height: 140px;
    }

    .problem-legend {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 140px;
      padding-right: 5px;

      .legend-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;

        .legend-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .legend-text {
          color: #fff;
          flex: 1;
          line-height: 1.8;
        }

        .legend-num {
          color: #fff;
          font-weight: bold;
          font-size: 12px;
        }
      }
    }
  }
}
</style>

<style>
.amap-logo {
  display: none !important;
}

/* 自定义地图标记样式 */
.custom-marker {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.custom-marker .marker-icon {
  width: 24px;
  height: 32px;
  background-size: contain;
  background-repeat: no-repeat;
}

.custom-marker.type-1 .marker-icon {
  background-image: url('./imgs/pointsIcon01.png');
}

.custom-marker.type-2 .marker-icon {
  background-image: url('./imgs/pointsIcon02.png');
}

.custom-marker.type-3 .marker-icon {
  background-image: url('./imgs/pointsIcon03.png');
}

.custom-marker .marker-label {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid #00d4ff;
}
</style>
